export default {
  OrderMovedToPending: 'shipmentLogs.OrderMovedToPending',
  OrderMovedToPendingWithoutSource: 'shipmentLogs.OrderMovedToPendingWithoutSource',
  OrderCopied: 'shipmentLogs.OrderCopied',
  OrderMovedPendingToOnHold: 'shipmentLogs.OrderMovedPendingToOnHold',
  OrderMovedOnHoldToPending: 'shipmentLogs.OrderMovedOnHoldToPending',
  OrderMovedToOnHoldDueToAddress: 'shipmentLogs.OrderMovedToOnHoldDueToAddress',
  OrderMovedToOnHoldDueToCC: 'shipmentLogs.OrderMovedToOnHoldDueToCC',
  OrderTrackingUploaded: 'shipmentLogs.OrderTrackingUploaded',
  OrderTrackingUploadFailed: 'shipmentLogs.OrderTrackingUploadFailed',
  ShipOptionMappingResolved: 'shipmentLogs.ShipOptionMappingResolved',
  OrderPlacedStoreIntegration: 'shipmentLogs.OrderPlacedStoreIntegration',
  FulfillmentCenterChanged: 'shipmentLogs.FulfillmentCenterChanged',
  FulfillmentCenterChangedWithoutUser: 'shipmentLogs.FulfillmentCenterChangedWithoutUser',
  OrderSplit: 'shipmentLogs.OrderSplit',
  OrderMovedToException: 'shipmentLogs.OrderMovedToException',
  OrderMovedToExceptionWithoutSource: 'shipmentLogs.OrderMovedToExceptionWithoutSource',
  OrderItemsUpdated: 'shipmentLogs.OrderItemsUpdated',
  OrderItemsUpdatedWithoutUser: 'shipmentLogs.OrderItemsUpdatedWithoutUser',
  OrderShipOptionChanged: 'shipmentLogs.OrderShipOptionChanged',
  OrderShipOptionChangedWithoutUser: 'shipmentLogs.OrderShipOptionChangedWithoutUser',
  OrderMovedFromOnHoldToPendingDueToReserveDateMet: 'shipmentLogs.OrderMovedFromOnHoldToPendingDueToReserveDateMet',
  OrderTypeMovedToOnHoldDueToReserveDateNotMet: 'shipmentLogs.OrderTypeMovedToOnHoldDueToReserveDateNotMet',
  OrderLabelValidated: 'shipmentLogs.OrderLabelValidated',
  OrderItemExclusionReason: 'shipmentLogs.OrderItemExclusionReason',
  OrderItemExclusionReasonWithoutSource: 'shipmentLogs.OrderItemExclusionReasonWithoutSource',
  BatchLabelsValidated: 'shipmentLogs.BatchLabelsValidated',
  OrderCleanSweeped: 'shipmentLogs.OrderCleanSweeped',
  OrderCancelled: 'shipmentLogs.OrderCancelled',
  OrderAddressChangedFromSourceByUser: 'shipmentLogs.OrderAddressChangedFromSourceByUser',
  OrderAddressChangedFromSource: 'shipmentLogs.OrderAddressChangedFromSource',
  OrderAddressChanged: 'shipmentLogs.OrderAddressChanged',
  OrderMovedToOnHoldWithReasonAndPerformedBy: 'shipmentLogs.OrderMovedToOnHoldWithReasonAndPerformedBy',
  OrderMovedToOnHoldWithReason: 'shipmentLogs.OrderMovedToOnHoldWithReason',
  OrderMovedToOnHoldWithoutReason: 'shipmentLogs.OrderMovedToOnHoldWithoutReason',
  ShipOptionChangedForInternationalOrderWithShipOptions: 'shipmentLogs.ShipOptionChangedForInternationalOrderWithShipOptions',
  ShipOptionChangedForInternationalOrder: 'shipmentLogs.ShipOptionChangedForInternationalOrder',
  ReleaseExceptionOrder: 'shipmentLogs.ReleaseExceptionOrder',
  PickerExceptionRegisteredForInventoryWithReason: 'shipmentLogs.PickerExceptionRegisteredForInventoryWithReason',
  PickerExceptionRegisteredForInventory: 'shipmentLogs.PickerExceptionRegisteredForInventory',
  PickerExceptionRegistered: 'shipmentLogs.PickerExceptionRegistered',
  OrderDimensionSource: 'shipmentLogs.OrderDimensionSource',
  LabelGeneratedLog: 'shipmentLogs.LabelGeneratedLog',
  OrderUnAcknowledged: 'shipmentLogs.OrderUnAcknowledged',
  ShippingLabelRefunded: 'shipmentLogs.ShippingLabelRefunded',
  OrderInvoiceChanged: 'shipmentLogs.OrderInvoiceChanged',
  OrderInvoiceChangedFromTo: 'shipmentLogs.OrderInvoiceChangedFromTo',
  OrderLabelManuallyPrinted: 'shipmentLogs.OrderLabelManuallyPrinted',
  ShipOptionUpgraded: 'shipmentLogs.ShipOptionUpgraded',
  ShipOptionUpgradedFromTo: 'shipmentLogs.ShipOptionUpgradedFromTo',
  ShipOptionChangedFromMediaMail: 'shipmentLogs.ShipOptionChangedFromMediaMail',
  OrderImportedToException: 'shipmentLogs.OrderImportedToException',
  Inserted: 'shipmentLogs.Inserted',
  Picked: 'shipmentLogs.Picked',
  Packed: 'shipmentLogs.Packed',
  Labeled: 'shipmentLogs.Labeled',
  Validated: 'shipmentLogs.Validated',
  PreTransit: 'shipmentLogs.PreTransit',
  InTransit: 'shipmentLogs.InTransit',
  OutForDelivery: 'shipmentLogs.OutForDelivery',
  Delivered: 'shipmentLogs.Delivered',
  DeliveryException: 'shipmentLogs.DeliveryException',
  SplitAtFC: 'shipmentLogs.SplitAtFC',
  OrderFulfillmentSlaUpdated: 'shipmentLogs.OrderFulfillmentSlaUpdated',
  OrderFulfillmentSlaUpdatedWithPerformedByMessage: 'shipmentLogs.OrderFulfillmentSlaUpdatedWithPerformedByMessage',
  OrderMovedByMoveTool: 'shipmentLogs.OrderMovedByMoveTool',
  ShipmentPickedupByCarrier: 'shipmentLogs.ShipmentPickedupByCarrier',
  OrderOnHoldReasonResolved: 'shipmentLogs.OrderOnHoldReasonResolved',
  OrderOnHoldReasonResolvedAndPerformedBy: 'shipmentLogs.OrderOnHoldReasonResolvedAndPerformedBy',
  OrderOnHoldReasonAdded: 'shipmentLogs.OrderOnHoldReasonAdded',
  ShipmentTracking: 'shipmentLogs.ShipmentTracking',
  ShipOptionUpgradedDueToCarrierFailure: 'shipmentLogs.ShipOptionUpgradedDueToCarrierFailure',
  ShipOptionChangedDueToCustomerPreference: 'shipmentLogs.ShipOptionChangedDueToCustomerPreference',
  ShipOptionChangedDueToUnavailability: 'shipmentLogs.ShipOptionChangedDueToUnavailability',
  PickInProgress: 'shipmentLogs.PickInProgress',
  ShipOptionChanged: 'shipmentLogs.ShipOptionChanged',
  CommercialInvoiceEmailSent: 'shipmentLogs.CommercialInvoiceEmailSent',
  SlaExtended: 'shipmentLogs.SlaExtended',
  SlaManuallyUpdated: 'shipmentLogs.SlaManuallyUpdated',
  ManualShipmentTrackingUpdatedLog: 'shipmentLogs.ManualShipmentTrackingUpdatedLog',
  AddressChangeDetail: 'shipmentLogs.AddressChangeDetail',
  InsuranceAmountAdded: 'shipmentLogs.InsuranceAmountAdded',
  OrderInTransitToShipBobSortCenter: 'shipmentLogs.OrderInTransitToShipBobSortCenter'
}
